import classes from "./PaymentArea.module.scss";
import { useEffect, useContext } from "react";
import Aside from "./Layout/Aside";
import AsideMob from "./Layout/AsideMob";
import Header from "./Layout/Header";
import Main from "./Layout/Main";
import { useDispatch, useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";
import { API_URL_SALES_ORDER } from "../../../constants/api";
import SystemContext from "../../../context/SystemContext";
import * as kApi from "../../../constants/api";
import { useMediaQuery, useTheme } from "@mui/material";
import { useSearchParams } from "react-router-dom";

const PaymentArea = ({ Products }) => {
  const payload = useSelector((state) => state.purchase);
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const PaymentMethod = searchParams.get("paymentMethod");
  const instantPay = searchParams.get("instant");

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  window.dataLayer = window.dataLayer || [];

  const dispatch = useDispatch();
  const { PurchaseInfo, setUserCards, setPixResponse, setPurchaseInfo } =
    useContext(SystemContext);
  const [, , , fetchCheckout_order] = useFetch({
    autoInit: false,
  });
  const [, , , fetchGetCards] = useFetch({
    autoInit: false,
  });
  const [userInfo, , userInfoError, updateUserInfo] = useFetch({
    autoInit: false,
  });
  const { session } = useSelector((state) => state.session);

  useEffect(() => {
    if (userInfo && userInfo.customer_id) {
      setPurchaseInfo((prev) => ({
        ...prev,
        customer_id: userInfo.customer_id,
      }));
    }
  }, [userInfo])

  useEffect(() => {
    if (userInfoError) {
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "PaymentArea",
          step: "InvoiceData",
          errorList: userInfoError.data?.erros || userInfoError.data?.errors,
          invoice_state: JSON.parse(JSON.stringify(payload.PostData.invoice_info))
        },
        PostData: {
          invoice_info: payload.PostData.invoice_info
        },
        planInfo: {
          payment_method: PurchaseInfo.MethodChosen && PurchaseInfo.MethodChosen in PurchaseInfo && PurchaseInfo[PurchaseInfo.MethodChosen].type
        }
      });
    }
  }, [userInfoError]);

  useEffect(() => {
    if (payload && payload.planInfo && payload.planInfo.value) {
      const parseBRL = (val) => {
        if (typeof val === "number") return val;
        const str = String(val).replace(/[R$\s]/g, "");
        if (/,\d{1,2}$/.test(str)) {
          return parseFloat(str.replace(/\./g, "").replace(",", "."));
        }
        return parseFloat(str.replace(/,/g, ""));
      };
      const planValue = parseBRL(payload.planInfo.value);
      window.dataLayer.push({
        event: "add_to_cart", // O nome do evento que o GTM vai escutar
        ecommerce: {
          currency: "BRL",    // Moeda
          value: planValue,     //  converter para numerico 
          items: [
            {
              item_id: payload.PostData.product_id,
              item_name: payload.planInfo.planName,
              price: planValue,
              quantity: 1,
              periodicity: payload.planInfo.periodicity
            }
          ]
        }
      });
    }
  }, [payload])

  useEffect(() => {
    fetchGetCards({
      url: kApi.API_URL_SALES_CARDS,
      method: "GET",
      onSuccess: (response) => {
        setUserCards(response);
      },
    });
  }, []);
  const manageResponseBuyPlan = (response) => {
    if (response.message === "Another Payment in Process. Please try again later.") {
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "PaymentProcessing",
          step: "PaymentProcessing",
        },
        planInfo: {
          payment_method: PurchaseInfo.MethodChosen && PurchaseInfo.MethodChosen in PurchaseInfo && PurchaseInfo[PurchaseInfo.MethodChosen].type
        }
      });
      console.error("Erro:", response.message);
      // throw new Error(response.message || "Erro desconhecido");
    } else if (Array.isArray(response.message) && typeof (response.message) === "string" && response.message.filter(e => e.includes('invoice')).length > 0) {
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "PaymentArea",
          step: "InvoiceData",
          errorList: response.message,
        },
        PostData: {
          invoice_info: payload.PostData.invoice_info
        },
        planInfo: {
          payment_method: PurchaseInfo.MethodChosen && PurchaseInfo.MethodChosen in PurchaseInfo && PurchaseInfo[PurchaseInfo.MethodChosen].type
        }
      });
      // throw new Error(response.message || "Erro desconhecido");
    } else if (
      response.error &&
      response.message !== "Another Payment in Process. Please try again later."
    ) {
      dispatch({
        type: "PURCHASE",
        purchase: {
          message: response.message,
          content: "PaymentArea",
          step: "PaymentError",
        },
        planInfo: {
          payment_method: PurchaseInfo.MethodChosen && PurchaseInfo.MethodChosen in PurchaseInfo && PurchaseInfo[PurchaseInfo.MethodChosen].type
        }
      });
      console.error("Erro:", response.message);
      // throw new Error(response.message || "Erro desconhecido");
    } else if (payload.purchase.step === "DescPix" && response?.emv && response.qrcode) {
      setPixResponse(response);
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "PaymentArea",
          step: "PixQrCode",
        },
        planInfo: {
          periodicity: payload.PostData.periodicity,
          payment_method: PurchaseInfo.MethodChosen && PurchaseInfo.MethodChosen in PurchaseInfo && PurchaseInfo[PurchaseInfo.MethodChosen].type
        },
      });
    } else {
      setPixResponse(response);
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "PurchaseSuccess",
          step: "PurchaseSuccess",
        },
        planInfo: {
          periodicity: payload.PostData.periodicity,
          payment_method: PurchaseInfo.MethodChosen && PurchaseInfo.MethodChosen in PurchaseInfo && PurchaseInfo[PurchaseInfo.MethodChosen].type
        }
      });
    }
  }

  const BuyPlan = async () => {

    const parseBRL = (val) => {
      if (typeof val === "number") return val;
      const str = String(val).replace(/[R$\s]/g, "");
      if (/,\d{1,2}$/.test(str)) {
        return parseFloat(str.replace(/\./g, "").replace(",", "."));
      }
      return parseFloat(str.replace(/,/g, ""));
    };

    const planValue = parseBRL(payload.planInfo.value);
    window.dataLayer.push({
      event: "begin_checkout", // O nome do evento que o GTM vai escutar
      ecommerce: {
        currency: "BRL",    // Moeda
        value: planValue,      // Valor total dos itens adicionados
        items: [
          {
            item_id: payload.PostData.product_id,
            item_name: payload.planInfo.planName,
            price: planValue,
            quantity: 1,
            periodicity: payload.planInfo.periodicity
          }
        ]
      }
    });

    if (typeof PurchaseInfo[PurchaseInfo.MethodChosen] === "function") {
      PurchaseInfo[PurchaseInfo.MethodChosen] = await PurchaseInfo[PurchaseInfo.MethodChosen]();
    }
    let customer_id = PurchaseInfo.customer_id;
    if (!customer_id && userInfo && userInfo.customer_id)
      customer_id = userInfo.customer_id;

    if (!customer_id)
      customer_id = session?.my_user?.customer_id;

    const PostData = {
      sub: payload.PostData.sub,
      cupom_code: "",
      customer_id: customer_id,
      periodicity: payload.PostData.periodicity,
      currency: payload.PostData.currency,
      product_id: payload.PostData.product_id,
      payment_method: PurchaseInfo[PurchaseInfo.MethodChosen],
      invoice_info: payload.PostData.invoice_info,
      email: payload.PostData.email,
    };
    fetchCheckout_order({
      url: API_URL_SALES_ORDER,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: PostData,
      onSuccess: (response) => {
        manageResponseBuyPlan(response);
        if (response?.error && response?.message) {
          window.dataLayer.push({
            event: "checkout_error",
            error_message: (Array.isArray(response.message) ? response.message.join(", ") : response.message),
            error_code: response.status || 200,
            error_step: "pagamento"
          });
        }
      },
      onError: (error) => {
        manageResponseBuyPlan(error?.response?.data);
        if (error?.response?.data?.error && error?.response?.data?.message) {
          window.dataLayer.push({
            event: "checkout_error",
            error_message: (Array.isArray(error.response.data.message) ? error.response.data.message.join(", ") : error.response.data.message),
            error_code: error.response.status,
            error_step: "pagamento"
          });
        }
      },
    });
  };

  const UpdateUserInfo = (onSuccess = () => { }, onFailure = () => { }) => {
    /*       const fields = Object.keys(payload.PostData.invoice_info);
          const FieldsFilled = fields.every(
            (key) => payload.PostData.invoice_info[key] && payload.PostData.invoice_info[key] !== ""
          );
          if (!FieldsFilled) {
            console.log("Campos obrigatórios não preenchidos");
            dispatch({
              type: "PURCHASE",
              purchase: {
                content: "PaymentArea",
                step: "InvoiceData",
                errorList: ["Preencha todos os campos obrigatórios."],
              },
              PostData: {
                invoice_info: payload.PostData.invoice_info
              },
              planInfo: {
                payment_method: PurchaseInfo.MethodChosen && PurchaseInfo.MethodChosen in PurchaseInfo && PurchaseInfo[PurchaseInfo.MethodChosen].type
              }
            });
            return;
          } */
    try {
      const updateUserPayload = {
        country: payload.PostData.invoice_info.country,
        zipcode: payload.PostData.invoice_info.zipcode,
        document: payload.PostData.invoice_info.document,
        name: payload.PostData.invoice_info.name.replace(/[^\p{L}\s]/gu, ""),
        phone: payload.PostData.invoice_info.phone,
        street: payload.PostData.invoice_info.street,
        number: payload.PostData.invoice_info.number,
        complement: payload.PostData.invoice_info.complement,
        city: payload.PostData.invoice_info.city,
        state: payload.PostData.invoice_info.state,
        neighborhood: payload.PostData.invoice_info.neighborhood,
        email: session?.email
      }
      updateUserInfo({
        url: kApi.API_URL_SALES_USER,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        data: updateUserPayload,
        onSuccess: (response) => {
          onSuccess(response);
        },
        onError: (error) => {
          console.log("Error updating user info:", error);
          onFailure(error);
        }
      })
    } catch (error) {
      console.log("Error updating user info:", error);
    }
  }

  return (
    <div className={classes.PurchaseMain}>
      <header className={classes.HeaderContent}>
        <Header />
      </header>
      <main className={classes.MainContent}>
        <Main />
      </main>
      {!isMobile ? (
        <aside className={classes.AsideContent}>
          <Aside BuyPlan={BuyPlan} UpdateUserInfo={UpdateUserInfo} Products={Products} PaymentMethod={PaymentMethod} instantPay={instantPay} />
        </aside>
      ) : (
        <aside className={classes.AsideMobile}>
          <AsideMob BuyPlan={BuyPlan} UpdateUserInfo={UpdateUserInfo} Products={Products} PaymentMethod={PaymentMethod} instantPay={instantPay} />
        </aside>
      )
      }

    </div>
  );
};
export default PaymentArea;